import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./en";
import { fr } from "./fr";
import { zh } from "./zh";
import { de } from "./de";
import { ja } from "./ja";
import { it } from "./it";
import { ru } from "./ru";
import config from "./config";
import { detectLanguageFromURL } from "./detectLanguage";
// Portal application namespace
import { portalEn } from "./portal/en";
import { portalFr } from "./portal/fr";
import { portalZh } from "./portal/zh";
import { portalDe } from "./portal/de";
import { portalRu } from "./portal/ru";
import { portalJa } from "./portal/ja";
import { portalIt } from "./portal/it";

// Detect initial language from URL before i18n initializes
const detectedLang = detectLanguageFromURL();
// Restore saved portal language preference — but dedicated domain always wins
// (e.g. on thailandelite.fr, always French regardless of localStorage)
const savedLang = typeof localStorage !== "undefined" ? localStorage.getItem("te_portal_lang") : null;
const initialLang = detectedLang || savedLang || config.defaultLanguage;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en, portal: portalEn },
    fr: { translation: fr, portal: portalFr },
    zh: { translation: zh, portal: portalZh },
    de: { translation: de, portal: portalDe },
    ja: { translation: ja, portal: portalJa },
    it: { translation: it, portal: portalIt },
    ru: { translation: ru, portal: portalRu },
  },
  lng: initialLang,
  fallbackLng: "en",
  defaultNS: "translation",
  ns: ["translation", "portal"],
  interpolation: { escapeValue: false },
});

export default i18n;
